import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import currencyActions from '../actions/currency';

function getCurrencies(store) {
    request.get(`/${config.url_prefix}/api/getCurrencies?site=${store.getState().system.siteName}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(currencyActions.currencyServiceError('ipmob.internal.server.error'));
            } else {
                try {
                    const res = JSON.parse(response.text);
                    if (!res || res.code >= 400 || res.statusCode >= 400) {
                        store.dispatch(currencyActions.currencyServiceError('ipmob.error.process.request'));
                    } else {
                        store.dispatch(currencyActions.getCurrenciesSuccess(res));
                    }
                } catch (exp) {
                    store.dispatch(currencyActions.currencyServiceError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getCurrencies;
